import { SmileyAngry, SmileySad, SmileyMeh, Smiley, SmileyWink } from '@phosphor-icons/react';
import { ResponsiveContainer, LineChart, XAxis, Line } from 'recharts';

const MOOD_ICONS = [SmileyAngry, SmileySad, SmileyMeh, Smiley, SmileyWink];
const MOOD_COLORS = ['#FF3B30', '#FF9500', '#A1A1AA', '#34C759', '#007AFF'];
const CHART_TICK_SMALL = { fill: '#71717A', fontSize: 9 };
const MOOD_DOT = { fill: '#FF3B30', r: 3 };

export default function MoodWidget({ moodLogged, moodValue, energyValue, moodHistory, onMoodSelect, onEnergySelect, onLogMood }) {
  return (
    <div className="tactical-card p-6" data-testid="mood-widget">
      <h3 className="text-xl font-bold tracking-tight mb-4">HOW DO YOU FEEL?</h3>
      {moodLogged ? (
        <div className="text-center py-2">
          <div className="text-[#34C759] font-bold mb-3">Mood logged!</div>
          <div className="flex justify-center gap-2 mb-4">
            {MOOD_ICONS.map((Icon, idx) => (
              <Icon key={`mood-display-${idx}`} weight={idx + 1 === moodValue ? 'fill' : 'regular'} className={`w-8 h-8 ${idx + 1 === moodValue ? 'text-[#FF3B30]' : 'text-[#71717A]/30'}`} />
            ))}
          </div>
          {moodHistory.length > 1 && (
            <div className="h-20 mt-2">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={moodHistory}>
                  <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fill: '#71717A', fontSize: 9 }} />
                  <Line type="monotone" dataKey="mood" stroke="#FF3B30" strokeWidth={2} dot={{ fill: '#FF3B30', r: 3 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="label-tactical mb-3">Mood</div>
          <div className="flex justify-between mb-4">
            {MOOD_ICONS.map((Icon, idx) => (
              <button key={`mood-select-${idx}`} onClick={() => onMoodSelect(idx + 1)} data-testid={`mood-${idx + 1}`}
                className={`p-2 transition-all duration-200 ${moodValue === idx + 1 ? 'scale-125' : 'hover:scale-110 text-[#71717A] hover:text-white'}`}
                style={moodValue === idx + 1 ? { color: MOOD_COLORS[idx] } : {}}>
                <Icon weight={moodValue === idx + 1 ? 'fill' : 'regular'} className="w-8 h-8" />
              </button>
            ))}
          </div>
          <div className="label-tactical mb-3">Energy Level</div>
          <div className="flex gap-2 mb-4">
            {[1, 2, 3, 4, 5].map(level => (
              <button key={`energy-${level}`} onClick={() => onEnergySelect(level)} data-testid={`energy-${level}`}
                className={`flex-1 py-2 text-sm font-bold transition-all border ${energyValue === level ? 'border-[#FF3B30] bg-[#FF3B30]/10 text-[#FF3B30]' : 'border-white/10 text-[#71717A] hover:border-white/20'}`}>
                {level}
              </button>
            ))}
          </div>
          {moodValue > 0 && energyValue > 0 && (
            <button onClick={onLogMood} className="btn-primary w-full py-2.5 text-sm" data-testid="log-mood-button">
              Log Mood & Energy
            </button>
          )}
        </div>
      )}
    </div>
  );
}
